import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const GardianService = {

    async liste(id){
        try {
            const result = await axios.get(`${apiUrl}/gardian/${id}`  );
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },

    async getlisteadd(id,month,year){
        try {
            const result = await axios.get(`${apiUrl}/gardian/getlistadd/${id}/${month}/${year}`  );
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },

     async listeadd(id,month,year){
        try {
            const result = await axios.get(`${apiUrl}/gardian/getliste/${id}/${month}/${year}`  );
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },
      async add(month,year,selections,user,allSelectedPersons){
        try {
            const result = await axios.post(`${apiUrl}/gardian/add/`,{
               month:month,
               year:year,
               selections:selections,
               user:user,
               allSelectedPersons:allSelectedPersons
            });
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },

    async presence(){
        try {
            const result = await axios.post(`${apiUrl}/gardian/getpresence`);
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },
    async gettimetracking(directionid,services, mois, annee,type){
        try {

            const result = await axios.post(`${apiUrl}/gardian/gettimetracking`,{
                 directions:directionid,
                 mois:mois,
                 annee:annee,
                 services:services,
                 type:type
            });
            if (result) {
              return result.data;
            }
          } 
          catch (error) {
            if (error.response) {
              return error.response.data;
            }
          }
    },

    
  }

export default GardianService;